import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { ActiveDocket } from '../services/dashboard.service';
import { RouterLink } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { NgIf } from '@angular/common';

@Component({
    selector: 'hireitem-name-cell',
    template: `
    <span *ngIf="docket.categoryColor" [matTooltip]="docket.item_name">
      <span
        class="category-color-block"
        [style.background]="docket.categoryColor"
      ></span>
    </span>
    {{ docket.quantity }} x
    <a
      matTooltip="View product"
      matTooltip-position="left"
      tooltipHideDelay="0"
      [routerLink]="['/product/', docket.product_id]"
    >
      {{ docket.item_name }}
    </a>
  `,
    standalone: true,
    imports: [NgIf, MatTooltip, RouterLink]
})
export class HireItemNameItemsCellComponent implements AgRendererComponent {
  docket: ActiveDocket;

  agInit(params: any): void {
    this.docket = params.data as ActiveDocket;
  }

  refresh(params: any): boolean {
    this.docket = params.data;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}
